<template>
    <v-container>
        <!-- Chat button close desktop -->
        <div
            v-if="!$vuetify.display.mobile"
            :style="
                cardMode
                    ? ''
                    : 'position: fixed; right: 20px; bottom: 1vh; z-index: 10; display: none !important;'
            "
            v-show="!showDialog"
        >
            <v-avatar
                v-show="!showDialog"
                @click="showDialog = !showDialog"
                :style="cardMode ? '' : 'float: right; box-shadow: 10px 10px 7px rgba(0,0,0,0.06)'"
                v-resize="handleChatBtnAnimation"
                id="chat-btn-1"
            >
                <v-badge
                    :model-value="unreadMessageCount !== 0"
                    color="primary"
                    class="align-self-center"
                    :content="unreadMessageCount"
                >
                    <v-icon size="x-large">$fa-comments</v-icon>
                </v-badge>
            </v-avatar>
        </div>

        <!-- Chat button close smartphone -->

        <div
            v-else
            style="position: fixed; right: 10px; bottom: 60px; z-index: 10"
            v-show="!showDialog"
        >
            <v-avatar
                size="small"
                @click="showDialog = !showDialog"
                style="float: right; box-shadow: 10px 10px 7px rgba(0, 0, 0, 0.06)"
                icon="$fa-comments"
                color="primary"
            >
                <v-badge
                    :model-value="unreadMessageCount !== 0"
                    color="primary"
                    class="align-self-center"
                    :content="unreadMessageCount"
                >
                    <v-icon size="small">$fa-comments</v-icon>
                </v-badge>
            </v-avatar>
        </div>

        <v-dialog
            v-model="showDialog"
            fullscreen
            hide-overlay
            v-if="$vuetify.display.mobile && !cardMode"
        >
            <!-- Chat -->
            <v-card style="margin: 0; margin-bottom: -1vh" rounded="0">
                <v-card-title class="chat-header bg-primary p-5" color="primary-foreground">
                    <v-row wrap>
                        <v-col cols="11">
                            <p class="ma-0">{{ chatTitle }}</p>
                            <p class="ma-0 text-subtitle-1" v-if="chatSubtitle">
                                {{ chatSubtitle }}
                            </p>
                        </v-col>
                        <v-col cols="1">
                            <v-btn-icon
                                @click="showDialog = !showDialog"
                                class="ma-0"
                                :icon="showDialog ? '$remove' : '$add'"
                                color="primary-foreground"
                            />
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text
                    id="chatMessages"
                    ref="chatMessages"
                    style="overflow: hidden"
                    class="pa-0"
                    v-if="showDiscussion"
                >
                    <ChatConversation :messages="messages" ref="chatConversation" />
                </v-card-text>
                <!-- TextField -->
                <v-card-action
                    absolute
                    class="font-weight-medium pb-3"
                    color="primary-foreground"
                    v-if="showDiscussion"
                >
                    <v-col cols="12" class="py-0">
                        <v-divider />
                        <v-textarea
                            v-model="messageToSend"
                            @keyup.enter="send"
                            append-inner-icon="$send"
                            placeholder="Saisir votre message..."
                            @click:append-inner="send()"
                            rows="1"
                            bg-color="grey-lighten-3"
                            class="chat-textarea"
                        />
                    </v-col>
                    <v-col cols="12" class="py-0">
                        <ChatManager
                            :id="chatID"
                            :chatType="chatType"
                            @chatID="setChatID($event)"
                            @showDiscussion="discussionManager($event)"
                            @questionsNotReply="setBlink($event)"
                            @textToInsert="insertMessage($event)"
                        />
                    </v-col>
                </v-card-action>
            </v-card>
        </v-dialog>

        <!-- Chat -->
        <div
            :style="
                cardMode
                    ? 'box-shadow: none; padding: 0px'
                    : 'position: fixed; right: 20px; width: 318px; bottom: 1vh; z-index: 10; min-width: 318px; min-height: auto; max-width: 600px; max-height: 500px; overflow: auto;'
            "
            v-else-if="showDialog"
            class="resize-container d-flex flex-column align-items-start overflow-none"
        >
            <div class="resize-handler" @click=""></div>

            <v-toolbar class="elevation-0 py-2" rounded="0" v-if="!cardMode" color="primary">
                <v-toolbar-title>
                    <p class="ma-0">{{ chatTitle }}</p>
                    <p class="ma-0 text-subtitle-1" v-if="chatSubtitle">
                        {{ chatSubtitle }}
                    </p>
                </v-toolbar-title>
                <v-btn-icon
                    @click="closeChat"
                    class="ma-0"
                    color="primary-foreground"
                    :icon="showDialog ? '$remove' : '$add'"
                />
            </v-toolbar>

            <div style="overflow: hidden">
                <ChatConversation :messages="messages" />
            </div>

            <div class="d-flex flex-column bg-white w-100">
                <ChatManager
                    :id="chatID"
                    :chatType="chatType"
                    class="pa-0"
                    @chatID="setChatID($event)"
                    @showDiscussion="discussionManager($event)"
                    @questionsNotReply="setBlink($event)"
                    @textToInsert="insertMessage($event)"
                />
                <div class="textarea-container">
                    <v-textarea
                        class="my-textarea"
                        v-model="messageToSend"
                        @keyup.enter="send"
                        append-inner-icon="$send"
                        placeholder="Saisir votre message..."
                        @click:append-inner="send()"
                        rows="2"
                        no-resize
                        bg-color="grey-lighten-3"
                    />
                </div>
            </div>
        </div>
    </v-container>
</template>

<script lang="ts">
import { ChatBase } from "./ChatBase";
import ChatManager from "./ChatManager.vue";
import ChatConversation from "./ChatConversation.vue";
import { Component, toNative, Watch } from "vue-facing-decorator";

@Component({
    components: {
        ChatManager,
        ChatConversation,
    },
})
export class Chat extends ChatBase {
    get chatType(): string {
        return "OBJECT";
    }

    beforeMount() {
        this.handleChatBtnAnimation();
    }

    handleChatBtnAnimation(): void {
        const chatBtn: HTMLElement = document.querySelector("#chat-btn-1");

        if (chatBtn) {
            if (this.blinkBtn) {
                chatBtn.classList.remove("bg-primary");
                chatBtn.classList.toggle("btn-chat-animation", true);
            } else {
                chatBtn.classList.remove("btn-chat-animation");
                chatBtn.classList.toggle("bg-primary", true);
            }
        }
    }

    containerDocument = null;
    handlerDocument = null;

    mounted() {
        this.containerDocument = document.querySelector(".resize-container");
        this.handlerDocument = document.querySelector(".resize-handler");

        if (this.containerDocument && this.handlerDocument) {
            this.handlerDocument.addEventListener("mousedown", (e) => {
                e.preventDefault();
                this.resize(e);
                document.addEventListener("mousemove", this.resize);
                document.addEventListener("mouseup", this.stopResize);
            });
        }
    }

    resize(event) {
        console.log("resize");
        const newWidth =
            this.containerDocument.offsetWidth -
            (event.clientX - this.containerDocument.getBoundingClientRect().left);
        const newHeight =
            this.containerDocument.offsetHeight -
            (event.clientY - this.containerDocument.getBoundingClientRect().top);

        this.containerDocument.style.width = `${newWidth}px`;
        this.containerDocument.style.height = `${newHeight}px`;
    }

    stopResize() {
        document.removeEventListener("mousemove", this.resize);
        document.removeEventListener("mouseup", this.stopResize);
    }

    @Watch("blinkBtn")
    onBlinkBtnChange() {
        this.handleChatBtnAnimation();
    }

    closeChat() {
        this.showDialog = false;
    }
}

export default toNative(Chat);
</script>

<style lang="scss" scoped>
$primary-color: rgb(var(--v-theme-primary));
$primary-foreground-color: rgb(var(--v-theme-primary-foreground));
$orange-color: rgb(var(--v-theme-orange));

.btn-chat-animation {
    color: $primary-foreground-color;
    transition: all 0.25s 0;
    animation: componentAnimate 2s infinite;
}

@keyframes componentAnimate {
    0% {
        background-color: $primary-color;
        border-color: $primary-color;
    }

    50% {
        background-color: $orange-color;
        border-color: $orange-color;
    }

    to {
        background-color: $primary-color;
        border-color: $primary-color;
    }
}

.chat-textarea {
    font: 12px;
}

.resize-container {
    position: relative;
    /* Adding resize on both left and right  */
    //cursor: nwse-resize;
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
}

.resize-handler {
    position: absolute;
    cursor: nwse-resize;
    width: 10px;
    height: 10px;
    top: 0;
    left: 0;
    z-index: 10;
}

.fixed-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 10;
}

.chat-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: #1976d2; /* Ajuste selon ton thème */
}

.textarea-container {
    padding: 5px 10px;
}

textarea {
    font-size: 12.25px;
}
</style>
